module.exports = __webpack_public_path__ + "media/images/gallery/constellations/pegasus/peg_lines-417799d5ba23ce8bca623fa2083cdcc7.gif";